export default class CreateProjectCtrl {

  constructor ($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, GlobalConfig, GlobalSrv) {
    var createProjectVm = this
    const texts = GlobalConfig.appTexts
    const currentUser = JSON.parse($cookies.get('currentUser'))
    let post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId
      // name: currentUser.name
    }

    // //VARIABLES
    createProjectVm.idParent = WorkPlanModalSrv.getVariable()
    createProjectVm.isEditing = Number($stateParams.workplanTeacherActivityId)
    createProjectVm.rolList = []
    createProjectVm.projectFormulatedList = []
    createProjectVm.typeProjectList = []
    createProjectVm.financialArray = []
    createProjectVm.typeFinancial = []
    createProjectVm.groupInvestigationList = []
    createProjectVm.isTouchedfinancials = false
    createProjectVm.createOrEdit = 'Agregar'
    createProjectVm.textCreateOrEdit = texts.saved
    createProjectVm.createOrEditMV = texts.createDialog
    createProjectVm.active = GlobalConfig.generals.active
    createProjectVm.notActive = GlobalConfig.generals.notActive
    createProjectVm.notification = createProjectVm.notActive
    createProjectVm.rangeType = GlobalConfig.periods.rangeType
    createProjectVm.periodsArray = []
    createProjectVm.typePeriod = []
    createProjectVm.isTouchedPeriods = false
    createProjectVm.selectedTypePeriod = {}
    createProjectVm.selectedTypeFinancial = {}
    createProjectVm.isDisableButton = true
    createProjectVm.startDate = null
    createProjectVm.endDate = null
    createProjectVm.minStartDate = moment().toDate()
    createProjectVm.minEndDate = new Date()
    createProjectVm.isSaveButtonDisabled = false
    createProjectVm.disabled = false
    createProjectVm.isFeedback = currentUser.isFeedback
    createProjectVm.dt_start = $cookies.get('wp_start')
    createProjectVm.dt_end = $cookies.get('wp_end')
    createProjectVm.dt_startt = moment($cookies.get('wp_start'))._d
    createProjectVm.dt_endd = moment($cookies.get('wp_end'))._d

    // // //METHODS
    createProjectVm.validateForm = validateForm
    createProjectVm.showErrorMessages = showErrorMessages
    createProjectVm.hasError = hasError
    createProjectVm.startDateChange = startDateChange
    createProjectVm.funSelectedFinancial = funSelectedFinancial
    createProjectVm.validateCheklistFinancials = validateCheklistFinancials
    createProjectVm.funSelectedPeriod = funSelectedPeriod
    createProjectVm.validateCheklistPeriods = validateCheklistPeriods
    createProjectVm.close = close
    createProjectVm.addProject = addProject
    createProjectVm.addActivityProject = addActivityProject
    createProjectVm.cleanRangeType = cleanRangeType

    createProjectVm.updateRangeType = (val) => {
      createProjectVm.rangeType = val
      createProjectVm.periodsArray = []
      createProjectVm.startDate = null
      createProjectVm.endDate = null
    }
    createProjectVm.updateRangeData = (val) => {
      createProjectVm.periodsArray = val['periods']
      createProjectVm.startDate = val['dates'][0]
      createProjectVm.endDate = val['dates'][1]
    }

    activate()

    function activate () {
      if (createProjectVm.isEditing) {
        createProjectVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
        createProjectVm.activityId = GlobalConfig.minorActivityId.projectParent
        getDataProject()
      }

      if (createProjectVm.idParent) {
        createProjectVm.workplanTeacherActivityId = createProjectVm.idParent.children.workplanTeacherActivityId
        if (createProjectVm.idParent.children !== 'ADD') {
          createProjectVm.disabled = true
          createProjectVm.createOrEdit = 'Editar'
          createProjectVm.createOrEditMV = texts.editDialog
          createProjectVm.textCreateOrEdit = texts.modified
          setValues(createProjectVm.idParent.children)
        }
      }

      WorkPlanSrv.getDataFormProjects.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn)
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log(data)
        }
      )
    }

    function loadData (data) {
      createProjectVm.rolList = data.listRole.items
      createProjectVm.projectFormulatedList = data.listPorjectsFormulated
      createProjectVm.typeFinancial = data.listFinancial
      createProjectVm.typeProjectList = data.listTypePorject.items
      createProjectVm.groupInvestigationList = data.academicUnit
      createProjectVm.typePeriod = data.listPeriods
      updateView()
    }

    function showErrorMessages (input) {
      if (input) {
        return input.$dirty || input.$touched
      } else {
        return false
      }
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function validateForm (form) {
      return form.$invalid ||
             createProjectVm.validateCheklistPeriods()
    }

    function updateView () {
      createProjectVm.viewLoaded = false
      $timeout(() => {
        createProjectVm.viewLoaded = true
      }, 1)
    }

    function funSelectedFinancial (financial, checked) {
      if (checked) {
        if (!createProjectVm.financialArray.includes(financial.financialId)) {
          createProjectVm.financialArray.push(financial.financialId)
        }
      } else {
        let index = createProjectVm.financialArray.indexOf(financial.financialId)
        if (index !== -1) {
          createProjectVm.financialArray.splice(index, 1)
        }
      }
      createProjectVm.isTouchedfinancials = true
    }

    function validateCheklistFinancials () {
      return (createProjectVm.rangeType > 0 ? createProjectVm.financialArray.length < 1 : false)
    }

    function startDateChange () {
      let m = moment(createProjectVm.startDate)
      createProjectVm.minEndDate = m.isValid() ? m.add(0, 'days').toDate() : null
    }

    function validateCheklistPeriods () {
      return (createProjectVm.rangeType === 1 ? createProjectVm.periodsArray.length < 1 : false)
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createProjectVm.periodsArray.includes(period.periodId)) {
          createProjectVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createProjectVm.periodsArray.indexOf(period.periodId)
        if (index !== -1) {
          createProjectVm.periodsArray.splice(index, 1)
        }
      }

      const selectedPeriods = Object.values(createProjectVm.selectedTypePeriod)

      for (const selected of selectedPeriods) {
        if(selected){
          createProjectVm.isDisableButton = false
          break
        }
        createProjectVm.isDisableButton = true
      }

      createProjectVm.isTouchedPeriods = true
    }

    function close () {
      WorkPlanModalSrv.setVariable({status: false})
      return $mdDialog.hide()
    }

    function addProject (isExecution) {
      let origin = GlobalConfig.activityTypeId.originActivityPlanning
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function createJson (origin) {
      var project = {
        activityId: GlobalConfig.minorActivityId.projectParent,
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        name: createProjectVm.title,
        description: createProjectVm.description,
        hoursChildren: createProjectVm.hoursChildren,
        hoursPlanning: createProjectVm.plannedHours,
        porjectsFormulatedId: createProjectVm.projectFormulated,
        itemRoleId: createProjectVm.rol,
        itemTypePorjectId: createProjectVm.typeProject,
        academicUnitId: createProjectVm.groupInvestigation,
        isNotification: createProjectVm.notification,
        timeRangeTypeId: createProjectVm.rangeType,
        origin: origin,
        isFeedbackActivity: createProjectVm.isFeedback
      }

      // Financiadores
      var arrayFinancial = []
      for (var index in createProjectVm.financialArray) {
        var temp = {
          financialId: createProjectVm.financialArray[index]
        }
        arrayFinancial.push(temp)
      }
      project.financial = arrayFinancial

      if (createProjectVm.isEditing) {
        project.workplanTeacherActivityId = createProjectVm.workplanTeacherActivityId
      }

      if (parseInt(createProjectVm.rangeType) == GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        createProjectVm.startDate = null
        createProjectVm.endDate = null
        for (var index in createProjectVm.periodsArray) {
          var temp = {
            periodId: createProjectVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        project.periods = arrayPeriod
      } else {
        project.startDate = createProjectVm.startDate
        project.endDate = createProjectVm.endDate
      }
      createProjectVm.modalType = texts.modalTypeId.project
      addOrEditProject(project, createProjectVm.modalType)
    }

    function addOrEditProject (project, modalType) {
      let action = 'ADD'
      if (createProjectVm.workplanTeacherActivityId) {
        action = 'EDIT'
      }
      createProjectVm.isSaveButtonDisabled = true

      WorkPlanSrv.addActivityProject.save(project).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          project.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId
          project.hoursPlanned = project.hoursPlanning
          // let data = {
          //   idUser:  post.teacherId
          //   dsName: 'Notificación, se ha registrado actividades en investigación',
          //   dsDescription: 'El profesor ' + post.name + ' ha registrado actividades en investigación',
          //   idNotification_delivery_type: GlobalConfig.notificationType.email
          // }

          if (isProject(modalType)) {
            confirmProjectAction(modalType)
            // GlobalSrv.sendNotification(data)
          } else {
            WorkPlanModalSrv.setVariable({status: dataReturn.status, child: project, action: action})
            confirmProjectAction(modalType)
            // GlobalSrv.sendNotification(data)
            return $mdDialog.hide(true)
          }
        } else {
          createProjectVm.isSaveButtonDisabled = false
          console.log('Error Comunications')
        }
      }, function (data) {
        createProjectVm.isSaveButtonDisabled = false
      })
    }

    function confirmProjectAction (modalType) {
      let header = {
        createOrEdit: createProjectVm.createOrEditMV,
        textCreateOrEdit: createProjectVm.textCreateOrEdit,
        itemName: createProjectVm.title,
        nameModal: (isProject(modalType) ? texts.modalTypeName.project : texts.modalTypeName.activity),
        modalType: modalType
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function getDataProject () {
      let post = {
        workplanTeacherActivityId: parseInt(createProjectVm.workplanTeacherActivityId)
      }
      WorkPlanSrv.getProjectByActivityId.get(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          if (!dataReturn.data.parent) {
            createProjectVm.project = dataReturn.data.childs[0]
          } else {
            createProjectVm.project = dataReturn.data.parent
          }
          setValues(createProjectVm.project)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {

      })
    }

    function setValues (project) {
      const dateValueSetter = (date) => moment(date, 'YYYY-MM-DD').isValid() ? moment(date, 'YYYY-MM-DD').toDate() : null
      createProjectVm.title = project.name
      createProjectVm.groupInvestigation = project.academicUnitId
      createProjectVm.projectFormulated = project.projectFormulatedId
      createProjectVm.typeProject = project.listItemProjectTypeId
      createProjectVm.rol = project.listItemProjectRoleId
      createProjectVm.description = project.description ? project.description : '-'
      createProjectVm.rangeType = project.timeRangeTypeId
      createProjectVm.hoursChildren = project.hoursChildren
      createProjectVm.dt_start = moment(project.startDate)._d
      createProjectVm.dt_end = moment(project.endDate)._d
      createProjectVm.plannedHours = project.hoursPlanned
      createProjectVm.notification = Boolean(project.isNotification === 1)
      createProjectVm.periodsArray = []
      createProjectVm.selectedTypePeriod = {}
      createProjectVm.financialArray = []
      createProjectVm.selectedTypeFinancial = {}

      if (createProjectVm.rangeType == GlobalConfig.periods.rangeType) {
        createProjectVm.periodsArray = project.periodId.split(',').map(id => {
          createProjectVm.selectedTypePeriod[Number(id)] = true
          return Number(id)
        })
      }

      if (project.financialSourceId) {
        createProjectVm.financialArray = project.financialSourceId.split(',').map(id => {
          createProjectVm.selectedTypeFinancial[Number(id)] = true
          return Number(id)
        })
      }

      if (project.startDate) {
        var startDateNew = moment(project.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createProjectVm.minStartDate = moment(project.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createProjectVm.isEditing = true
    }

    function addActivityProject (activity) {
      createJsonActivity()
    }

    function createJsonActivity () {
      var arrayPeriod = []
      let activity = {
        activityId: GlobalConfig.minorActivityId.projectChild,
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        name: createProjectVm.title,
        description: createProjectVm.description,
        hoursChildren: createProjectVm.hoursChildren,
        hoursPlanning: createProjectVm.plannedHours,
        parentActivityId: createProjectVm.idParent.workplanTeacherActivityIdParent,
        timeRangeTypeId: createProjectVm.rangeType,
        isFeedbackActivity: createProjectVm.isFeedback
      }

      if (createProjectVm.rangeType == GlobalConfig.periods.rangeType) {
        var aux = []
        for (var index in createProjectVm.periodsArray) {
          var temp = {
            periodId: createProjectVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
          aux.push(createProjectVm.periodsArray[index])
        }
        activity.periods = arrayPeriod
        activity.periodId = aux.join(',')
      } else {
        activity.startDate = createProjectVm.dt_start
        activity.endDate = createProjectVm.dt_end
      }
      if (createProjectVm.isEditing) {
        activity.workplanTeacherActivityId = createProjectVm.workplanTeacherActivityId
      }

      createProjectVm.modalType = texts.modalTypeId.activity
      addOrEditProject(activity, createProjectVm.modalType)
    }

    function cleanRangeType () {
      if (parseInt(createProjectVm.rangeType) == GlobalConfig.periods.rangeType) {
        createProjectVm.dt_start = null
        createProjectVm.dt_end = null
        createProjectVm.startDate = null
        createProjectVm.endDate = null
      } else {
        createProjectVm.periodsArray = []
        createProjectVm.selectedTypePeriod = null
        createProjectVm.isDisableButton = true
      }
    }

    function isProject (value) {
      return value == texts.modalTypeId.project
    }
  }// FIN DEL CONSTRUCTOR

  rbPlanifications (bool) {
    if (bool) {
      this.startDate = null
      this.endDate = null
    } else {
      this.periodsArray = []
      this.selectedTypePeriod = null
      this.startDate = null
      this.endDate = null
    }
  }

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }
}

CreateProjectCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', '$stateParams', '$state', 'GlobalConfig', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/projects/createProject/createProjectCtrl.js